import { getSiteVersion } from './env.js';

const BEACON_DOMAINS = {
  dev: {
    '2.0': 'https://beacon.beta.shutterfly.com/log',
    '3.0': 'https://nrd-api3.dev.shutterfly.com/nrd/log',
  },
  stage: {
    '2.0': 'https://beacon.stage.shutterfly.com/log',
    '3.0': 'https://nrd-api3.stage.shutterfly.com/nrd/log',
  },
  prod: {
    '2.0': 'https://beacon.shutterfly.com/log',
    '3.0': 'https://nrd-api3.shutterfly.com/nrd/log',
  },
};

const APIKEY_DOMAINS = {
  dev: {
    '2.0': '',
    '3.0': 'd9ylKEVogc9QtRmDnJyKFgk4DdK8iDG7',
  },
  stage: {
    '2.0': '',
    '3.0': '6aGAIEelXSZ6AIt1KY7CJIiBCEq7LWy0',
  },
  prod: {
    '2.0': '',
    '3.0': 'zlrHU7h6cTGTApk3IbOU0aVuxlEJkPeA',
  },
};

console.log('[consent-logger] env check - ', process.env.ENV);

export function forwardBeacon(logObject: unknown) {
  if (typeof logObject !== 'object' || logObject === null) {
    console.error(
      '[consent-logger] forwardBeacon called with non-object payload',
      logObject,
    );
    return;
  }
  const siteVersion = getSiteVersion();
  const env = (process.env.ENV || 'dev') as keyof typeof BEACON_DOMAINS;
  const beaconDomain = BEACON_DOMAINS[env][siteVersion];
  if (beaconDomain) {
    fetch(beaconDomain, {
      headers: {
        'x-api-key': APIKEY_DOMAINS[env][siteVersion] || '',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(logObject),
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
    }).catch((e) => {
      console.error('[consent-logger] failed to forwardBeacon', logObject, e);
    });
  }
}
